/**
 * Created by fers on 12.06.16.
 */
import Auth0Variables from './auth0-variables';
import Auth0Lock from 'auth0-lock';
import {displayError} from './errorDisplayer';
import {isExtensionIframe, sendToExtension} from './ExtensionCommunicate';
import config from '../../common/config';
import {getLocale} from '../locales';
import logout from './logout';
import Token from '../../../packages/extension/src/background/Token';
import {safeJSONparse} from "../../common/util/safeJSONparse";
import deferred from '../fw/deferred';
import { StorageAdapter } from '../utils/StorageAdapter.ts';

const REDIRECT_PATH_KEY = 'dativery-redirect-path';

/* save current path to session storage if it is not login/registration */
if (window.location.pathname !== '/' &&
    window.location.pathname !== '/login' &&
    window.location.pathname !== '/registration' &&
    window.location.pathname !== '/signup') {
    try {
        sessionStorage.setItem(REDIRECT_PATH_KEY, window.location.pathname + window.location.search + window.location.hash);
    } catch (e) {
        // ignore
    }
}

let options = {
	configurationBaseUrl: Auth0Variables.BASE_URL,
    theme: {
        logo: config.PUBLIC_CDN + '/assets/icons/1.0/icon64.png',
        primaryColor: '#E76049'
    },
    socialButtonStyle: 'big',
    allowForgotPassword: true,
    allowSignUp: true,
    language: getLocale(),
    plugins: [],
    closable: false,
    languageDictionary: {
        title: config.PRODUCT_NAME,
		emailInputPlaceholder: 'email@example.org'
    },
    auth: {
        responseType: 'token',
        redirectUrl: window.location.protocol + "//" + window.location.host + '/',
		// redirect: false,
		params: {
			state: JSON.stringify({
				"targetPath": window.location.pathname !== '/' ? window.location.pathname : null
			})
		}
    }
};
export const defaultOptions = options;

let lock = new Auth0Lock(
    Auth0Variables.AUTH0_CLIENT_ID,
    Auth0Variables.AUTH0_DOMAIN,
    options
);

let profile = null;
let loginTimeout = null;

let loginDeferred = null;

/* check if token is not expired */
if (Token.isExpired()) {
	Token.remove();
}

/* listen for login - if we show login screen in multiple tabs, they will login all at once */
function userTokenUpdate() {
	scheduleRefresh();

	/* are we doing refresh? */
	if (loginDeferred) {
		loginDeferred.resolve();
		loginDeferred = null;
	}
}
Token.startWatch(userTokenUpdate);

// Listening for the authenticated event
lock.on("authenticated", function(authResult) {
    // Use the token in authResult to getProfile() and save it to localStorage
    lock.getProfile(authResult.accessToken, function(error, newProfile) {
        if (error) {
            displayError(error);
            if (loginDeferred) {
                loginDeferred.reject(error);
            }
            return;
        }

        StorageAdapter.setSync('profile', JSON.stringify(newProfile));

        profile = newProfile;
        let token = authResult.idToken;
        // Save the JWT token.
        StorageAdapter.setSync('userToken', token);

        scheduleRefresh();

        sendToExtension({
            message: 'dativery-set-token',
            data: {token: token}
        });

        /* are we doing refresh? */
        if (loginDeferred) {
            loginDeferred.resolve();
            loginDeferred = null;
        }

		let state = safeJSONparse(authResult.state);
        let targetPath = state.targetPath;

        if (!targetPath || targetPath.length <= 1) {
             try {
                targetPath = sessionStorage.getItem(REDIRECT_PATH_KEY);
                sessionStorage.removeItem(REDIRECT_PATH_KEY);
            } catch (e) {
                // ignore
            }
        }

		if (targetPath && targetPath.length > 1) {
			// special case -> don't init react only to close the window
			if (targetPath === '/login-only') {
				window.close();
			}
			else {
				window.location.href = window.location.origin + targetPath;
			}
		}
    });
});

function scheduleRefresh() {
    if (loginTimeout) {
        clearTimeout(loginTimeout);
        loginTimeout = null;
    }

    lock.hide();

    loginTimeout = setTimeout(() => { // nosemgrep
		if (Token.isExpired()) {
			// For extension, don't show login as the current panel is fine, the next one will display NotLogged on itself
			if (isExtensionIframe()) {
                // nosemgrep
				const {lastPanelController} = require('../view/EmbededPanelController'); // nosemgrep
				if (lastPanelController && lastPanelController()) {
					lastPanelController().setState({
						loggedOut: !isLogged()
					});
				}
			} else if (window.location.hash !== '#tokenExpired') {
                Token.remove();
				window.location.hash = '#tokenExpired';
				window.location.reload();
			}
		}
    }, Token.getExpiration());

}

export function getProfile() {
    if (!profile) {
        profile = safeJSONparse(StorageAdapter.getSync('profile'));
    }

    return Promise.resolve(profile);
}

export function isLogged() {
	return !Token.isExpired();
}

export function onSignInRefresh() {
    if (!loginDeferred) {
		loginDeferred = new deferred();
    }

    let options = {
        params: {
            auth: {
                redirect: false
            }
        }
    };

    lock.show(options);

    return loginDeferred.promise;
}

export function onSignInClick(addons) {
    if (!loginDeferred) {
		loginDeferred = new deferred();
    }

    let options = {
        ...addons
    };

    // If forgotPassword option is specified, go directly to that screen
    if (options.forgotPassword) {
        options.initialScreen = 'forgotPassword';
        options.allowLogin = false;
        options.allowSignUp = false;
        options.closable = true;
    }

    lock.show(options);

    return loginDeferred.promise;
}

export function onSignOutClick() {
	return logout().then(() => {
		profile = null;

		sendToExtension({
			message: 'dativery-remove-token',
			data: {}
		});

		window.location = "/";
	});
}
